// extracted by mini-css-extract-plugin
export var content_desc = "guide-module--content_desc--e9303";
export var content_title = "guide-module--content_title--5f9c5";
export var guid_tab_wrap = "guide-module--guid_tab_wrap--e205a";
export var guide_wrapper = "guide-module--guide_wrapper--ee9af";
export var icon_wrap = "guide-module--icon_wrap--19049";
export var inner_tab_content = "guide-module--inner_tab_content--a9ba6";
export var list_title = "guide-module--list_title--1f63d";
export var tab_content_wrap = "guide-module--tab_content_wrap--f2e71";
export var tab_list_content = "guide-module--tab_list_content--8e4eb";
export var tab_list_wrap = "guide-module--tab_list_wrap--87456";
export var tab_panel = "guide-module--tab_panel--bc19b";